import type { ExtractPostRoutes, RouteSegment } from '@openclassrooms/sdk';
import useMutationRequest from './useMutationRequest';
import type { ApiRoutes, PostRequestBuilder, RequestOption, MutateOptions } from '../types';
export default function usePost(path, mutationOptions) {
  return useMutationRequest("POST", path, mutationOptions);
}